import { Icon, IconProps } from "@chakra-ui/react";

export default function FlowerPurpleBackgroundNew(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 44 44"
      fill="none"
      boxSize="100%"
      {...props}
    >
      <circle cx="22" cy="22" r="22" fill="#8491D9" />
      <path
        d="M33.6742 18.7838C33.6742 18.5864 33.6525 18.3939 33.6101 18.2083C33.3277 16.9477 32.1372 16 30.7117 16C29.076 16 27.7493 17.2458 27.7493 18.7828C27.7493 17.2458 26.4225 16 24.7868 16C23.2389 16 21.9684 17.1155 21.8361 18.538C21.7039 17.1155 20.4344 16 18.8855 16C17.2498 16 15.923 17.2458 15.923 18.7828C15.925 17.2468 14.5982 16.001 12.9625 16.001C11.4501 16.001 10.2043 17.0652 10.0237 18.4393C10.0089 18.5528 10 18.6673 10 18.7838C10 18.8253 10.001 18.8677 10.003 18.9092C10.001 18.998 10 19.0859 10 19.1747C10 25.7058 15.2942 31 21.8253 31C28.3564 31 33.6505 25.7058 33.6505 19.1747C33.6505 19.1629 33.6505 19.15 33.6505 19.1382C33.6663 19.0217 33.6752 18.9042 33.6752 18.7838H33.6742Z"
        fill="#DBF3DA"
      />
    </Icon>
  );
}
